import firmwareSaga from './firmware';

export default [
  ...firmwareSaga,
];